import React from "react";
import "../App.css";
import Electronic from "../component/electronic.png";
import Jobs from "../component/businessman.png";
import Phone from "../component/cell-phone.png";
import Fashion from "../component/fashion.png";
import Furniture from "../component/furniture.png";
import House from "../component/property.png";
import Animal from "../component/animal-kingdom.png";

class Mobile extends React.Component {
    render() {
        return (
            <div>
                <div className="main-categories">
                    <div className="categories">
                        <div className="browse">
                            <p>Browse categories</p>
                        </div>
                        <div className="see-all">
                            <u>
                                <span>See all</span>
                            </u>
                        </div>
                    </div>
                    <div className="main-icons">
                        <div className="cat-icons">
                            <div className="icon">
                                <div className="inner-icons">
                                    <div className="icon-image">
                                        <img
                                            id="clr-1"
                                            src={Electronic}
                                            alt=""
                                        />
                                        <p>
                                            ELECTRONIC &amp; HOME <br />
                                            APPLIANCES
                                        </p>
                                    </div>
                                    <div className="icon-image">
                                        <img id="clr-2" src={Phone} alt="" />
                                        <p>MOBILES</p>
                                    </div>
                                    <div className="icon-image">
                                        <img
                                            id="clr-3"
                                            src={Furniture}
                                            alt=""
                                        />
                                        <p>
                                            FURNITURE &amp; HOME
                                            <br />
                                            DECORE
                                        </p>
                                    </div>
                                </div>
                                <div className="inner-icons">
                                    <div className="icon-image">
                                        <img id="clr-4" src={House} alt="" />
                                        <p>PROPERTY FOR SALE</p>
                                    </div>
                                    <div className="icon-image">
                                        <img id="clr-5" src={Jobs} alt="" />
                                        <p>JOBS</p>
                                    </div>
                                    <div className="icon-image">
                                        <img id="clr-6" src={Animal} alt="" />
                                        <p>ANIMALS</p>
                                    </div>
                                </div>
                                <div className="inner-icons">
                                    <div className="icon-image">
                                        <img
                                            id="clr-7"
                                            src={Electronic}
                                            alt=""
                                        />
                                        <p>VEHCILE</p>
                                    </div>
                                    <div className="icon-image">
                                        <img id="clr-8" src={Fashion} alt="" />
                                        <p>FASHION</p>
                                    </div>
                                    <div className="icon-image">
                                        <img
                                            id="clr-9"
                                            src={Electronic}
                                            alt=""
                                        />
                                        <p>
                                            BOOKS SPORTS &amp; <br />
                                            HOBBIES
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default Mobile;
